// Enregistrement du Service Worker pour la PWA

export function register() {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      
      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('[PWA] Service Worker enregistré:', registration.scope);
          
          // Vérifier les mises à jour
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // Nouvelle version disponible
                  console.log('[PWA] Nouvelle version disponible');
                  showUpdateNotification(newWorker);
                }
              });
            }
          });
        })
        .catch((error) => {
          console.error('[PWA] Erreur enregistrement Service Worker:', error);
        });
      
      // Écouter les messages du Service Worker
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'SKIP_WAITING') {
          window.location.reload();
        }
      });
    });
  }
}

// Afficher une notification de mise à jour
function showUpdateNotification(worker: ServiceWorker) {
  // Créer un toast de notification
  const toast = document.createElement('div');
  toast.innerHTML = `
    <div style="
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: #16a34a;
      color: white;
      padding: 16px 24px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 9999;
      display: flex;
      align-items: center;
      gap: 12px;
      font-family: system-ui, sans-serif;
      max-width: 90vw;
    ">
      <span>Nouvelle version disponible</span>
      <button id="pwa-update-btn" style="
        background: white;
        color: #16a34a;
        border: none;
        padding: 8px 16px;
        border-radius: 4px;
        font-weight: 600;
        cursor: pointer;
      ">Mettre à jour</button>
    </div>
  `;
  
  document.body.appendChild(toast);
  
  document.getElementById('pwa-update-btn')?.addEventListener('click', () => {
    worker.postMessage({ type: 'SKIP_WAITING' });
    toast.remove();
  });
}

// Désenregistrer le Service Worker (pour le développement)
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// Vérifier si l'app est installée
export function isAppInstalled(): boolean {
  return window.matchMedia('(display-mode: standalone)').matches || 
         (window.navigator as any).standalone === true;
}

// Écouter l'installation de la PWA
export function listenToInstallPrompt(callback: (promptEvent: any) => void) {
  let deferredPrompt: any;
  
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    callback(deferredPrompt);
  });
  
  return () => {
    deferredPrompt = null;
  };
}

// Demander l'installation
export async function promptInstall(deferredPrompt: any): Promise<boolean> {
  if (!deferredPrompt) return false;
  
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  return outcome === 'accepted';
}
